import {PropertyAnnotation, Fragmenter} from 'substance'

class EmphasisNode extends PropertyAnnotation {
}

EmphasisNode.type = 'emphasis'

// hint for rendering in presence of overlapping annotations
EmphasisNode.fragmentation = Fragmenter.ANY

export {EmphasisNode}
